import * as React from "react";
import type { SVGProps } from "react";
const SvgSquareSizeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#square-size-icon_svg__a)">
      <path
        fill="#333"
        d="M9.6.925 1.075 4.037A.38.38 0 0 0 .8 4.4v10.475l8.8-3.15zm.8 0v10.8l2.4.838V5.837l3.6 1.325v6.676l2.8 1V4.4a.38.38 0 0 0-.275-.363zM7.2 5.6v4.037l-3.6 1.4v-4zm2.8 6.838L1.125 15.6l8.75 3.563c.04 0 .083.037.162.037.041 0 .122.003.163-.037l8.675-3.563z"
      />
    </g>
    <defs>
      <clipPath id="square-size-icon_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSquareSizeIcon;
